{
    "use strict";

    const scriptId = document.currentScript.dataset.id;

    document.querySelectorAll(`.deck-template#${scriptId}`).forEach(elem => {
        const outputTargetId = elem.id;
        const target = document.querySelector(`.output-${outputTargetId}`);
        const modalTemplate = document.getElementById(`form-${outputTargetId}`);
        const modal = document.getElementById(`modal-${outputTargetId}`);
        const layer = document.getElementById(`layer-${outputTargetId}`);

        const cards = {};
        elem.cloneNode(true).content.querySelectorAll(".card").forEach(card => {
            const type = card.dataset.type;
            const count = isNaN(Number(card.dataset.count))? 0 : Number(card.dataset.count);
            if(type in cards){
                cards[type]["items"].push(card);
                cards[type]["count"] += count;
            }else{
                cards[type] = {
                    count: count,
                    items: [card]
                };
            }
        });

        const frag = document.createDocumentFragment();
        for(let key in cards){
            const container = document.createElement("div");
            const title = document.createElement("h3");
            title.textContent = `${key}(${cards[key].count})`;
            container.appendChild(title);
            const parent = document.createElement("div");
            for(let card of cards[key]["items"]){
                parent.appendChild(card);
            }
            container.appendChild(parent);
            frag.appendChild(container);
        }
        target.appendChild(frag);

        document.querySelectorAll(`.card-deck-area.id-${scriptId} .card-deck-output .card-title`).forEach(elem => {
            elem.addEventListener("click", e => {
                const id = e.currentTarget.dataset.id;
                const query = `.card-deck-area.id-${scriptId} .card-deck-output-img .img-id-${id}`;
                document.querySelector(query)?.click();
            });
        });

        const targetImg = document.querySelector(`.output-img-${outputTargetId}`);
        for(let key in cards){
            const container = document.createElement("div");
            const title = document.createElement("h3");
            title.textContent = `${key}(${cards[key].count})`;
            container.appendChild(title);
            const tagetImgParent = document.createElement("div");
            tagetImgParent.classList.add("card-wrap");
            for(let card of cards[key]["items"]){
                const div = document.createElement("div");
                div.dataset.id = card.dataset.productid;
                div.classList.add(`img-id-${card.dataset.productid}`);
                if(!card.dataset.img) return;

                const floatDiv = document.createElement("div");
                floatDiv.classList.add("float-number");
                floatDiv.textContent = card.dataset.count;
                div.appendChild(floatDiv);
                const img = document.createElement("img");
                img.src = card.dataset.img;
                div.appendChild(img);
                div.dataset.img = card.dataset.img;
                div.addEventListener("click", e => {
                    const t = e.currentTarget;
                    modal.innerHTML = "";
                    modal.appendChild(modalTemplate.cloneNode(true).content.getElementById(`card-form-${t.dataset.id}`));
                    modal.classList.add("active");
                    layer.classList.add("active");
                });
                tagetImgParent.appendChild(div);
            }
            container.appendChild(tagetImgParent);
            targetImg.appendChild(container);
        }

        // const targetImg = document.querySelector(`.output-img-${outputTargetId}`);
        // const tagetImgParent = document.createElement("div");
        // tagetImgParent.classList.add("card-wrap");
        // elem.cloneNode(true).content.querySelectorAll(".card").forEach(card => {
        //     const div = document.createElement("div");
        //     div.dataset.id = card.dataset.productid;
        //     div.classList.add(`img-id-${card.dataset.productid}`);
        //     if(!card.dataset.img) return;

        //     const floatDiv = document.createElement("div");
        //     floatDiv.classList.add("float-number");
        //     floatDiv.textContent = card.dataset.count;
        //     div.appendChild(floatDiv);
        //     const img = document.createElement("img");
        //     img.src = card.dataset.img;
        //     div.appendChild(img);
        //     div.dataset.img = card.dataset.img;
        //     div.addEventListener("click", e => {
        //         const t = e.currentTarget;
        //         modal.innerHTML = "";
        //         modal.appendChild(modalTemplate.cloneNode(true).content.getElementById(`card-form-${t.dataset.id}`));
        //         modal.classList.add("active");
        //         layer.classList.add("active");
        //     });
        //     tagetImgParent.appendChild(div);
        // });
        // targetImg.appendChild(tagetImgParent);

        layer.addEventListener("click", e => {
            modal.classList.remove("active");
            e.currentTarget.classList.remove("active");
        });
    });
}